import { Flex } from "@bdo/cornerstone-ui";
import { RiLoader5Line } from "@remixicon/react";

interface LoaderProps {
  message?: string;
}

export function Loader({ message }: Readonly<LoaderProps>) {
  return (
    <Flex
      align="center"
      justify="center"
      className="h-full"
      direction="column"
      gap="md"
    >
      <RiLoader5Line size="56px" className="animate-spin text-primary" />
      {message && <div className="text-lg text-mono-dark">{message}</div>}
    </Flex>
  );
}
